/** Converts duration (in seconds) to a string */
export function durationSecondsAsString(secs: number): string {
    const wholeSecs = Math.floor(secs);
    const hours = Math.floor(wholeSecs / 3600);
    const minutes = Math.floor((wholeSecs / 60) % 60);

    return (String(hours).padStart(2, '0') + ':' + String(minutes).padStart(2, '0'));
}

export function testUrl(url: string): Promise<void> {
    // make a normal GET fetch. if it fails return rejected promise, otherwise return resolved
    return fetch(url)
        .catch(() => Promise.reject())
        .then(() => Promise.resolve());
}

export function sleep(ms: number): Promise<void> {
    return new Promise(resolve => setTimeout(resolve, ms));
}

export function humanize(str: string): string {
    return str
        .replace(/^[\s_]+|[\s_]+$/g, '')
        .replace(/[_\s]+/g, ' ')
        .replace(/(\b[a-z](?!\s))/g, function (m) { 
            return m.toUpperCase(); 
        });
}

export function getOrdinal(num: number): string {
    const suffixes = [ 'th', 'st', 'nd', 'rd' ];
    const value = num % 100;
    return num + (suffixes[(value - 20) % 10] || suffixes[value] || suffixes[0]);
}

export const generateUniqueId = (): number => {
    return Date.now() + Math.floor(Math.random() * 1000000);
};

export async function downloadFile(fileUrl: string, fileName: string): Promise<void> {
    try {
        const fileResponse = await fetch(fileUrl);
        const blob = await fileResponse.blob();

        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = fileName || 'download';
        document.body.appendChild(link);
        link.click();
        
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        console.error('Error downloading file:', error);
    }
}

export function getWorkUrl(workId: number): string {
    const baseUrl = `${window.location.protocol}//${window.location.host}`;
    const params = new URLSearchParams({ workId: String(workId) });
    
    return `${baseUrl}/?${params.toString()}`;
}
